import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import LogoHeader from '../../icons/LogoHeader'
import MegaMenuItem from "./mainMenu/MegeMenuItem"
import BurgerMenu from './burgerMenu/BurgerMenu'
import { useBrowser } from 'js/hooks/useBrowser'
import {isMobiles} from '@helpers/browser';

const MegaMenuComponent = () => {
  const browser = useBrowser();

  const {
    menuDataLeft,
    menuDataRight,
    destinationsMenu,
    corporateMenu,
    logoUrl,
    logoAlt,
    logoAriaLabel,
    setting,
    backButtonLabel
  } = useSelector((state) => ({
    menuDataLeft: state.main.setting.megaMenu.leftMenu,
    menuDataRight: state.main.setting.megaMenu.rightMenu,
    destinationsMenu: state.main.setting.megaMenu.destinationsMenu,
    corporateMenu: state.main.setting.megaMenu.corporateMenu,
    logoUrl: state.main.setting.megaMenu.logoUrl,
    logoAlt: state.main.setting.megaMenu.logoAlt,
    logoAriaLabel: state.main.setting.megaMenu.logoAriaLabel,
    setting: state.main.setting,
    backButtonLabel: state.main.setting.megaMenu.backButtonLabel,
  }))

  const hideMenuItem = setting.hasOwnProperty('basket')
  const leftMenuItems = { destinationsKey: { ...destinationsMenu }, ...menuDataLeft }
  const isDesktop = !isMobiles(browser)

  return (
    <>
      {isDesktop ? (
        <div className="megamenu-container">
          <div className="megamenu">
            <div className="megamenu__left">
              {Object.keys(leftMenuItems).map((key, index) => (
                <MegaMenuItem
                  {...leftMenuItems[key]}
                  key={key}
                  index={index}
                  hideMenuItem={hideMenuItem}
                />
              ))}
            </div>

            <div className="megamenu__item megamenu__item_logo-holder">
              <a className="site-logo" href={logoUrl} aria-label={logoAriaLabel}>
                <LogoHeader
                  alt={logoAlt}
                  role="img"
                  className={cx('adagio-logo')}
                  aria-hidden="true"
                />
                <span className="sr-only">{logoAlt}</span>
              </a>
            </div>

            <div className="megamenu__right">
              {Object.keys(menuDataRight).map((key, index) => (
                <MegaMenuItem
                  {...menuDataRight[key]}
                  classStyle="_right"
                  key={key}
                  index={index}
                  hideMenuItem={hideMenuItem}
                />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          <BurgerMenu
            destinationsMenu={destinationsMenu}
            menuDataLeft={menuDataLeft}
            menuDataRight={menuDataRight}
            corporateMenu={corporateMenu}
            homeUrl={logoUrl}
            backButtonLabel={backButtonLabel}
          />

          <div className="megamenu__item megamenu__item_logo-holder">
            <a className={cx("site-logo")} href={logoUrl} aria-label={logoAriaLabel}>
              <LogoHeader
                alt={logoAlt}
                role="img"
                aria-label={logoAriaLabel}
                className={'adagio-logo'}
              />
            </a>
          </div>
        </>
      )}
    </>
  )
}

MegaMenuComponent.displayName = 'MegaMenuComponent'

export default MegaMenuComponent
